export default "__VITE_ASSET__I4LD41sP__"